/** Shared CMS form field length and numeric bounds. */
export const FIELD_CONSTRAINTS = {
    TEXT_MIN: 5,
    TEXT_MAX: 70,
    DESCRIPTION_MAX: 700,
    NUMBER_MIN: 0,
};
